<template>
  <div class="table">
    <div class="container">
      <el-form :model="formData" :rules="rules" ref="formData" :label-position="labelPosition" label-width="150px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('base.carriers.carriersCode')" prop="supplierCode">
              <el-input class="de-input" v-model="formData.supplierCode" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base.carriers.carriersName')" prop="supplierName">
              <el-input class="de-input" v-model="formData.supplierName" clearable></el-input>
            </el-form-item>
          </el-col>
        <!-- </el-row>
        <el-row :gutter="16"> -->
          <el-col :span="12">
            <el-form-item :label="$t('base.carriers.carriersAddress')" prop="address">
              <el-input class="de-input" v-model="formData.address" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base.carriers.carriersCountry')">
              <el-input class="de-input" v-model="formData.country" clearable></el-input>
            </el-form-item>
          </el-col>
        <!-- </el-row>
        <el-row :gutter="16"> -->
          <el-col :span="12">
            <el-form-item :label="$t('base.carriers.carriersProvince')">
              <el-input class="de-input" v-model="formData.province" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base.carriers.carriersCity')" prop="city">
              <el-input class="de-input" v-model="formData.city" clearable></el-input>
            </el-form-item>
          </el-col>
        <!-- </el-row>
        <el-row :gutter="16"> -->
          <el-col :span="12">
            <el-form-item :label="$t('base.carriers.carriersPostCode')">
              <el-input class="de-input" v-model="formData.postCode" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base.carriers.carriersTelephoneNo')">
              <el-input class="de-input" v-model="formData.telephoneNo" clearable></el-input>
            </el-form-item>
          </el-col>
        <!-- </el-row>
        <el-row :gutter="16"> -->
          <el-col :span="12">
            <el-form-item :label="$t('base.carriers.carriersEmailAddress')">
              <el-input class="de-input" v-model="formData.emailAddress" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row class="btn-row">
        <el-button size="mini" type="primary" @click="saveCarrier('formData')">{{$t('common.save')}}</el-button>
        <el-button size="mini" type="primary" @click="cancel">{{$t('common.cancel')}}</el-button>
      </el-row>
    </div>
  </div>
</template>
<script>
import router from '../../../router';
import { add } from "../../../api/base-data/supplier";
import { Message } from "element-ui";
export default {
  name: 'supplier-add',
  data() {
    return {
      formData: {
        supplierCode: '',
        supplierName: '',
        address: '',
        country: '',
        province: '',
        city: '',
        postCode: '',
        telephoneNo: '',
        emailAddress: '',
        type: 'CARRIER',
        status: '1'
      },
      labelPosition: 'right',
      rules: {
        supplierCode: [{ required: true, message: this.$t('base.carriers.carriersCodeInput'), trigger: 'blur' }],
        supplierName: [{ required: true, message: this.$t('base.carriers.carriersNameInput'), trigger: 'blur' }],
        city: [{ required: true, message: this.$t('base.carriers.carriersCityInput'), trigger: 'blur' }],
      }
    }
  },
  methods: {
    //保存承运商主数据
    saveCarrier(formData) {
      this.$refs[formData].validate((valid) => {
        //前段验证是否通过
        if (valid) {
          add(this.formData).then((res) => {
            //数据是否插入成功
            if (res.meta.success) {
              Message({ message: this.$t('common.saveSuccess'), type: "success" });
              this.cancel();
            } else {
              Message({ message: res.meta.msg, type: "error" });
            }
          })

        } else {
          return false;
        }
      })

    },
    //取消编辑承运商主数据，返回主数据查询
    cancel() {
      router.replace({
        path: './carrier'
      });
    },
  }
}
</script>
<style scoped>
.btn-row {
  margin-bottom: 10px;
  text-align: center;
}
.de-input {
  /* width: 60%; */
  width: 100%;
}
.handle-input {
  /* width: 60%; */
  width: 100%;
}
</style>